import { SkinsAndAnimationBoundsProvider, Spine } from '@esotericsoftware/spine-pixi-v7'
import * as PIXI from 'pixi.js'
import { gsap } from "gsap";
import { PixiPlugin } from "gsap/PixiPlugin";
import { pixiApp } from "./initializePixi.js";
import { createSpineObject, createSpineBGObject } from './flags.js';
import { pumpIdleAnimation } from './pump.js';
import { demoState, gameData, networkData } from './data.js';
import { settings } from '../settings.js';
import { scaleFactor, scaleFactorScaleToFit, tweenFade, viewAppear } from './utility.js';
import { clickToStopCommendation, controlWinFlow } from './commendation.js';
import { isSimulate } from '../bridge.js';
import { simulatorVersionInfo } from './simulator.js';
import { popUpShow, setupPopup } from "./popups/popUp.js";
import { background } from './constants.js';
import { setIsPopupOpen, setupSettings } from './popups/settings.js';
import { setupDimmer, setupSkipBtn } from './popups/dimmer.js';
import { setupCoins } from './popups/coins.js';
import serviceInit, { isOnline, setLang } from './networkService.js';
import { createLoseScreenText } from './popups/loseScreen.js';
import { playDisable, playMainBg, playMinus, playOff, playOn, playPlus, playPopUpOpen } from './soundManager.js';
import { handleAutoPlay, handleTickets, handleTurboPlay, makeInitialSetupDisable, showJackpotPanel } from './gameLogic.js';
import { setupJackpotPanel } from './jackpotPanel.js';
import { setupBetHistory } from './popups/betHistory.js';

gsap.registerPlugin(PixiPlugin);
PixiPlugin.registerPIXI(PIXI);

let uiCreated = false
let stopPos = 0;

const containers = {
  backdropContainer: new PIXI.Container(),
  rootContainer: new PIXI.Container(),
  bgContainer: new PIXI.Container(),
  flagsContainer: new PIXI.Container(),
  popupContainer: new PIXI.Container(),
  coinsContainer: new PIXI.Container(),
  settingsContainer: new PIXI.Container(),
  tutorialContainer: new PIXI.Container(),
  settingsButtonContainer: new PIXI.Container(),
  tutorialButtonContainer: new PIXI.Container(),
}

let banderitasCollection = []

const gameAssets = {
  skipBtn:null,
  hideLoseScreenBtnGraphic: null,
  loseMessage: null,
  PopUpMessage: null,
  page1Container: null,
  page2Container: null,
  paginationContainer: null,
  background: null,
  bgPig: null,
  banderitasOne: null,
  banderitasOneBG: null,
  banderitasTwo: null,
  banderitasTwoBG: null,
  banderitasThree: null,
  banderitasThreeBG: null,
  banderitasFour: null,
  banderitasFourBG: null,
  banderitasFive: null,
  banderitasFiveBG: null,
  banderitasSix: null,
  banderitasSixBG: null,
  banderitasSeven: null,
  banderitasSevenBG: null,
  banderitasEight: null,
  banderitasEightBG: null,
  banderitasNine: null,
  banderitasNineBG: null,
  pump: null,
  string_banderitas_top: null,
  string_banderitas_middle: null,
  string_banderitas_bottom: null,
  menu: null,
  footer: null,
  char_portrait: null,
  char: null,
  rows: [],
  nameContainer: null,
  nameText: null,
  coin_container: null,
  name_container: null,
  tickets: null,
  tickets_container: null,
  ticketsNumber: null,
  winnings: null,
  winnings_container: null,
  winningsNumber: null,
  coin_container: null,
  gameScreen: null,
  backdrop: null,
  balanceText: null,
  commendation: null,
  commendationValueBitmap: null,
  amazingBitmap: null,
  amazingWinValueBitmap: null,
  dimmer: null,
  settingsBase: null,
  settingsBtn: null,
  tutorialBase: null,
  tutorialBtn: null,
  p1_title: null,
  p1Image: null,
  p1_text: null,
  p1_text_art: null,
  p2_image: null,
  p2_title: null,
  p2_text01: null,
  p2_text02: null,
  soundBtn: null,
  musicBtn: null,
  vibrateBtn: null,
  closeBtn: null,
  tutorialCloseBtn: null,
  languageBtn: null,
  supportBtn: null,
  invitesBtn: null,
  coin1: null,
  coin2: null,
  coin3: null,
  coin4: null,
  coin5: null,
  coin6: null,
  coin7: null,
  coin8: null,
  coin9: null,
  coin10: null,
  coin11: null,
  coin12: null,
  coin13: null,
  coin14: null,
  coin15: null,
  coin16: null,
  coin17: null,
  coin18: null,
  popUpBase: null,
  popUpClose: null,
  popUpText: null,
  numberOfGames: [],
  gameItemContainer: [],
  partition: [],
  textOfGames: null,
  gameBetsContainer: null,
  numberOfBets: [],
  spineObj: [],
  tutArray: [],
  tutSelected: [],
  jackpotPanelContainer: null,
  jackpotPanelSprite: null,
  grandWinDisplayAmount: 0,
  majorWinDisplayAmount: 0,
  minorWinDisplayAmount: 0,
  grandJackpotNumberArray: [],
  majorJackpotNumberArray: [],
  minorJackpotNumberArray: [],
  _pauseDuration: 100,
  p4_image: null,
  historyContent: ['Date', 'Time', 'Pattern', 'Multiplier', 'Stake', 'Before\nBalance', 'After\nBalance', 'Win\nAmount', 'Status']
}

function createAppUI(pixiState) {
  if (demoState.isDemo) networkData.showAutoTurbo = true;

  setupContainers()
  setupBackdrop()
  setupGameScreen()
  setupBackground()
  setupLogo()
  setupPump()
  setupStrings()
  setupBanderitas()
  setupMenuButton()
  setupFooter()
  setupDimmer()
  setupJackpotPanel()
  setupCommendation()
  setupCoins()
  setupSkipBtn()

  createLoseScreenText()
  setupAmazing()
  setupSettings()
  setupBetHistory()
  playMainBg(true)
  setupPopup()
  gameData.pixiStates = pixiState;
  uiCreated = true
  resetPixiGame(window.innerWidth, window.innerHeight)
  if (isSimulate) simulatorVersionInfo()
  serviceInit()
  // if(pixiDiv.width && pixiDiv.height) resetPixiGame(pixiDiv.width, pixiDiv.height)
}
// let tutorialMenu = false
// function setupMenu(tutorialMenu){
//   if(tutorialMenu)setupTutorial()
//   setupSettings()
//   }
function setupFTUE() {
  gameAssets.dimmer.visible = true;
  gameAssets.dimmer.alpha = 1;


  const text = new PIXI.Text("Languages", {
    fontFamily: "Arial",
    fontSize: 55,
    fill: ["#ffffff", "#ffcc00"],
    fontWeight: "bold",
    stroke: "#000000",
    strokeThickness: 4,
    dropShadow: true,
    dropShadowColor: "#000000",
    dropShadowBlur: 6,
    dropShadowAngle: Math.PI / 6,
    dropShadowDistance: 4,
    align: "center"
  });

  text.anchor.set(0.5);
  text.scale.set(2.3)
  text.y = -310
  gameAssets.FTUEpopUp = new PIXI.Sprite(PIXI.Assets.get('main_board'));
  gameAssets.FTUEpopUp.anchor.set(0.5);

  const width = gameAssets.FTUEpopUp.width;

  gameAssets.FTUEpopUp.resize = (w, h) => {
    gameAssets.FTUEpopUp.x = w * 0.5
    gameAssets.FTUEpopUp.y = h * 0.45
    gameAssets.FTUEpopUp.width = gameAssets.gameScreen.width * 0.8
    gameAssets.FTUEpopUp.height = gameAssets.gameScreen.height * 0.3
  }
  gameAssets.FTUEpopUp.zIndex = 5001
  containers.bgContainer.addChild(gameAssets.FTUEpopUp)


  gameAssets.engLang = new PIXI.Sprite(PIXI.Assets.get('lang_english'));
  gameAssets.engLang.anchor.set(0.5);
  gameAssets.engLang.y = -70;
  gameAssets.engLang.scale.set(0.46);
  gameAssets.engLang.interactive = true;
  gameAssets.engLang.cursor = 'pointer'

  gameAssets.tagLang = new PIXI.Sprite(PIXI.Assets.get('lang_tagalog'));
  gameAssets.tagLang.anchor.set(0.5);
  gameAssets.tagLang.y = gameAssets.engLang.y + 310;
  gameAssets.tagLang.scale.set(0.46);
  gameAssets.tagLang.interactive = true;
  gameAssets.tagLang.cursor = 'pointer'

  gameAssets.tagLang.on("pointerdown", () => {
    gameAssets.tagLang.scale.set(0.34)
  })

  gameAssets.tagLang.on("pointerup", (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      gameAssets.tagLang.scale.set(0.45)
      showTutorial("tag");
      stopPos = -985
      setLang("tl", true)
    }
  })

  gameAssets.engLang.on("pointerdown", () => {
    gameAssets.engLang.scale.set(0.34)
  })

  gameAssets.engLang.on("pointerup", (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      gameAssets.engLang.scale.set(0.45)
      showTutorial("en");
      stopPos = -870
      setLang("en", true)
    }

  })

  gameAssets.engLang.on("pointerover", () => {
    gameAssets.engLang.scale.set(0.55);
    gameAssets.engLang.tint = 0xcccccc;
  });

  gameAssets.engLang.on("pointerout", () => {
    gameAssets.engLang.scale.set(0.45);
    gameAssets.engLang.tint = 0xffffff;
  });

  gameAssets.tagLang.on("pointerover", () => {
    gameAssets.tagLang.scale.set(0.55);
    gameAssets.tagLang.tint = 0xcccccc;
  });

  gameAssets.tagLang.on("pointerout", () => {
    gameAssets.tagLang.scale.set(0.45);
    gameAssets.tagLang.tint = 0xffffff;
  });

  gameAssets.FTUEpopUp.addChild(text, gameAssets.tagLang, gameAssets.engLang)
}

function setupArrow(w, h) {
  gameAssets.ftueArrow = new PIXI.Sprite(PIXI.Assets.get("arrow_down"));
  gameAssets.ftueArrow.anchor.set(0.5);

  gameAssets.ftueArrow.zIndex = 8000

  let pulsate = 0.8;
  if (/Mobi|Android|iPhone/i.test(navigator?.userAgent)) {
    gameAssets.ftueArrow.scale.set(2);
    pulsate = 2.4
  } else {
    gameAssets.ftueArrow.scale.set(0.6);

  }

  gameAssets.ftueArrow.interactive = true;
  gameAssets.ftueArrow.cursor = 'pointer'
  gameAssets.ftueArrow.visible = false;

  gameAssets.ftueArrow.on('pointerdown', () => {
    gameAssets.ftueArrow.visible = false;
    gameData.ftueScroll = true;
  })

  gsap.timeline({ repeat: -1, yoyo: true })
    .to(gameAssets.ftueArrow, {
      pixi: {
        scale: pulsate
      },
      duration: 0.3,
      ease: "power1.inOut",
    });

  let upThreshold = 20

  if (/Mobi|Android|iPhone/i.test(navigator?.userAgent)) {
    upThreshold = 70
  }
  gameAssets.ftueArrow.resize = (w, h) => {
    gameAssets.ftueArrow.x = w * 0.5
    gameAssets.ftueArrow.y = gameAssets.tutorialFootCont.y - upThreshold
    // gameAssets.ftueArrow.y = h * 0.5
  }

  gameAssets.ftueArrow.resize(w, h)

  containers.bgContainer.addChild(gameAssets.ftueArrow);
}

function ftueScroll(delta) {
  gameAssets.ftue_p4_image.y = gameAssets.ftue_p4_image.y - 1.5 * delta;

  if (gameAssets.ftue_p4_image.y < stopPos) {
    gameData.ftueScroll = false;
  }
}

function clearFtue() {
  gameAssets.tutorialCont.visible = false;
  gameAssets.tutorialFootCont.visible = false;
  gameAssets.dimmer.visible = false;
  gameAssets.skip.visible = false;
  gameAssets.ftueArrow.visible = false;
  makeInitialSetupDisable(false)

  if (networkData.isJackpot) showJackpotPanel()
}

function showTutorial(language) {
  gameAssets.FTUEpopUp.visible = false;
  setupMask();

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const minWidth = settings.originalWidth;
  const minHeight = settings.originalHeight;

  const scaleX = windowWidth < minWidth ? minWidth / windowWidth : 1;
  const scaleY = windowHeight < minHeight ? minHeight / windowHeight : 1;
  const scale = scaleX > scaleY ? scaleX : scaleY;
  const width = windowWidth * scale;
  const height = windowHeight * scale;

  gameAssets.ftueContainer = new PIXI.Container();
  gameAssets.ftueContainer.zIndex = 100000
  gameAssets.ftueContainer.name = "container-ftue"

  gameAssets.skip = new PIXI.Sprite(PIXI.Assets.get("close_b_normal"));//play_b_normal
  gameAssets.skip.anchor.set(0.5);
  gameAssets.skip.scale.set(2)
  gameAssets.skip.zIndex = 5001;
  gameAssets.skip.interactive = true;
  gameAssets.skip.cursor = 'pointer'

  gameAssets.skip.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      clearFtue()
    }
  })

  let skipWidth = language == 'en' ? 0.13 : 0.13;
  let skipHeight = language == 'en' ? 0.08 : 0.08
  let skipX = language == 'en' ? 2.5 : 2.5

  gameAssets.skip.resize = (w, h) => {
    gameAssets.skip.x = w * 0.5 + gameAssets.gameScreen.width / skipX
    gameAssets.skip.y = h * 0.43 - gameAssets.PageMask.height * 0.72
    gameAssets.skip.width = scale*50//gameAssets.gameScreen.width * skipWidth;
    gameAssets.skip.height = scale*50//gameAssets.gameScreen.height * skipHeight;
    };

  gameAssets.skip.resize(width, height)

  containers.bgContainer.addChild(gameAssets.skip)


  gameAssets.tutorialCont = new PIXI.Container();
  gameAssets.tutorialCont.zIndex = 5001;
  gameAssets.tutorialCont.name = 'tutorialcon';

  const p1_Image = new PIXI.Sprite(PIXI.Assets.get(`tutorial1_FT_${language}`));
  p1_Image.anchor.set(0.5);
  p1_Image.x = language === 'en' ? -20 : -25;
  p1_Image.scale.set(1);

  const p2_Image = new PIXI.Sprite(PIXI.Assets.get(`tutorial2_FT_${language}`));
  p2_Image.anchor.set(0.5);
  p2_Image.x = -5;
  p2_Image.visible = false;
  const p2_scale = language == 'en' ? 1 : 1.3
  p2_Image.scale.set(p2_scale);


  const p3_Image = new PIXI.Sprite(PIXI.Assets.get(`tutorial3_FT_${language}`));
  p3_Image.anchor.set(0.5);
  p3_Image.x = -15;
  p3_Image.y = 15
  p3_Image.visible = false;
  p3_Image.scale.set(0.9);

  const p5_Image = new PIXI.Sprite(PIXI.Assets.get(`tutorial5_FT_${language}`));
  p5_Image.anchor.set(0.5);
  p5_Image.x = 5;
  p5_Image.y = language == 'en' ? 0 : 5;  // Initial Position
  p5_Image.visible = false;
  const scale5 = language == 'en' ? 0.75 : 0.62
  p5_Image.scale.set(scale5);

  if (networkData.showAutoTurbo) {

    gameAssets.ftue_p4_image = new PIXI.Sprite(PIXI.Assets.get(`tutorial4_FT_${language}`));
    gameAssets.ftue_p4_image.anchor.set(0.5);
    gameAssets.ftue_p4_image.x = 5;
    gameAssets.ftue_p4_image.y = language == 'en' ? 910 : 1005;  // Initial Position
    gameAssets.ftue_p4_image.visible = false;
    gameAssets.ftue_p4_image.scale.set(0.85);


    let isDragging = false;
    let startY = 0;
    let p4_startY = 0;
    const initialY = language == 'en' ? 910 : 1005; // Store the initial position
    const dragSpeed = 0.2; // 🐢 Lower = slower drag

    gameAssets.ftue_p4_image.interactive = true;
    gameAssets.ftue_p4_image.cursor = "grab";

    gameAssets.ftue_p4_image.on("pointerdown", (event) => {
      isDragging = true;
      startY = event.data.global.y;
      p4_startY = gameAssets.ftue_p4_image.y;
      gameAssets.ftue_p4_image.cursor = "grabbing";
    });

    gameAssets.ftue_p4_image.on("pointermove", (event) => {
      if (isDragging) {
        let deltaY = event.data.global.y - startY;
        let smoothedDeltaY = deltaY * dragSpeed;
        let newY = p4_startY + smoothedDeltaY;

        gameData.ftueScroll = false;
        gameAssets.ftueArrow.visible = true;

        const minY = language == 'en' ? -870 : -985;
        const maxY = initialY;
        gameAssets.ftue_p4_image.y = Math.max(minY, Math.min(maxY, newY));
      }
    });
    gameAssets.ftue_p4_image.on("pointerup", () => {
      isDragging = false;
      gameAssets.ftue_p4_image.cursor = "grab";
    });

    gameAssets.ftue_p4_image.on("pointerupoutside", () => {
      isDragging = false;
      gameAssets.ftue_p4_image.cursor = "grab";
    });
  } else {
    gameAssets.ftue_p4_image = new PIXI.Sprite(PIXI.Assets.get(`tutorial4_${language}_ftue_without_auto`));
    gameAssets.ftue_p4_image.anchor.set(0.5);
    gameAssets.ftue_p4_image.x = 5;
    gameAssets.ftue_p4_image.y = 0;
    gameAssets.ftue_p4_image.visible = false;
    gameAssets.ftue_p4_image.scale.set(0.75);
  }


  const selectLength = networkData.isJackpot ? 5 : 4

  if (networkData.isJackpot) {
    gameAssets.tutArray = [p1_Image, p2_Image, p3_Image, p5_Image, gameAssets.ftue_p4_image];
  } else {
    gameAssets.tutArray = [p1_Image, p2_Image, p5_Image, gameAssets.ftue_p4_image];
  }

  gameAssets.tutorialFootCont = new PIXI.Container();
  gameAssets.tutorialFootCont.pivot.set(0)
  gameAssets.tutorialFootCont.name = 'abcddd';
  gameAssets.tutorialFootCont.zIndex = 5001;

  let i = 0;

  const tutorialNormal = [];
  const tutorialSelected = [];


  for (let j = 0; j < selectLength; j++) {
    tutorialNormal[j] = new PIXI.Sprite(PIXI.Assets.get('tutorialNormal'));
    tutorialNormal[j].anchor.set(0.5);
    tutorialNormal[j].position.set(570 + j * 650, 10);
    tutorialNormal[j].scale.set(5);

    tutorialSelected[j] = new PIXI.Sprite(PIXI.Assets.get('tutorialSelected'));
    tutorialSelected[j].anchor.set(0.5);
    tutorialSelected[j].position.set(0, 0);
    tutorialSelected[j].visible = false;

    tutorialNormal[j].addChild(tutorialSelected[j]);
  }

  const leftNormal = new PIXI.Sprite(PIXI.Assets.get('left_b_normal'));
  leftNormal.anchor.set(0.5);
  leftNormal.position.set(-200, 10);
  leftNormal.scale.set(5);
  leftNormal.interactive = true;
  leftNormal.cursor = 'pointer';
  leftNormal.on('pointerover', () => { leftNormal.texture = PIXI.Assets.get('left_b_selected'); });
  leftNormal.on('pointerout', () => { leftNormal.texture = PIXI.Assets.get('left_b_normal'); });

  leftNormal.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      if (i > 0) {
        gameAssets.tutArray[i].visible = false;
        i--;
        gameAssets.tutArray[i].visible = true;
        updateTutorialIndicator();
        playMinus(true);
      } else {
        playDisable(true);
      }
      gameAssets.ftueArrow.visible = false;
    }
  });

  const rightNormal = new PIXI.Sprite(PIXI.Assets.get('right_b_normal'));
  rightNormal.anchor.set(0.5);
  const rightPose = networkData.isJackpot ? 3970 : 3180
  rightNormal.position.set(rightPose, 10);
  rightNormal.scale.set(5);
  rightNormal.interactive = true;
  rightNormal.cursor = 'pointer';
  rightNormal.on('pointerover', () => { rightNormal.texture = PIXI.Assets.get('right_b_selected'); });
  rightNormal.on('pointerout', () => { rightNormal.texture = PIXI.Assets.get('right_b_normal'); });

  rightNormal.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      if (i < gameAssets.tutArray.length - 1) {
        gameAssets.tutArray[i].visible = false;
        i++;
        gameAssets.tutArray[i].visible = true;
        updateTutorialIndicator();
        playPlus(true);
      } else {
        playDisable(true);
      }

      if (i == gameAssets.tutArray.length - 1 && networkData.showAutoTurbo) {
        gameAssets.ftueArrow.visible = true;
      } else {
        gameAssets.ftueArrow.visible = false;
      }
    }
  });

  function updateTutorialIndicator() {
    for (let j = 0; j < selectLength; j++) { // ✅ Fixed to support 4 images
      tutorialSelected[j].visible = i === j;
    }
  }

  const footWidth = gameAssets.tutorialFootCont.width;
  gameAssets.tutorialFootCont.addChild(...tutorialNormal, leftNormal, rightNormal);
  if (networkData.isJackpot) {
    gameAssets.tutorialCont.addChild(p1_Image, p2_Image, p3_Image, p5_Image, gameAssets.ftue_p4_image); // ✅ Ensured gameAssets.ftue_p4_image is added
  } else {
    gameAssets.tutorialCont.addChild(p1_Image, p2_Image, p5_Image, gameAssets.ftue_p4_image);
  }


  containers.bgContainer.addChild(gameAssets.tutorialCont, gameAssets.tutorialFootCont);
  let footPos = networkData.isJackpot ? 0.04 : 0.06

  gameAssets.tutorialFootCont.resize = (w, h) => {
    const scale = scaleFactor(gameAssets.gameScreen.width, footWidth)

    gameAssets.tutorialFootCont.y = h * 0.46 + gameAssets.PageMask.height / 2;
    gameAssets.tutorialFootCont.width = gameAssets.gameScreen.width * 0.62;
    gameAssets.tutorialFootCont.height = gameAssets.gameScreen.height * 0.041;
    gameAssets.tutorialFootCont.x = (w / 2) - gameAssets.tutorialFootCont.width / 2 + (gameAssets.gameScreen.width * footPos);
  };


  const tutorialContWidth = gameAssets.tutorialCont.width;

  gameAssets.tutorialCont.resize = (w, h) => {
    const scale = scaleFactor(gameAssets.gameScreen.width, tutorialContWidth)
    gameAssets.tutorialCont.x = w * 0.51;
    gameAssets.tutorialCont.y = h * 0.42;
    // gameAssets.tutorialCont.width = gameAssets.gameScreen.width * 0.78;
    // gameAssets.tutorialCont.height = gameAssets.gameScreen.height * 0.45;

    gameAssets.tutorialCont.scale.set(scale * 0.76)
  };


  gameAssets.tutorialCont.resize(width, height)
  gameAssets.tutorialFootCont.resize(width, height)
  setupArrow(width, height)
  // resetPixiGame();
  gameAssets.tutorialCont.mask = gameAssets.PageMask;
  updateTutorialIndicator();
}




function setupMask() {
  gameAssets.PageMask = new PIXI.Sprite(PIXI.Assets.get("gameScreen"));
  gameAssets.PageMask.anchor.set(0.5);
  gameAssets.PageMask.scale.set(1);
  gameAssets.PageMask.alpha = 1;

  gameAssets.PageMask.zIndex = 5001

  gameAssets.PageMask.resize = (w, h) => {
    gameAssets.PageMask.x = w * 0.5;
    gameAssets.PageMask.y = h * 0.42;
    gameAssets.PageMask.width = gameAssets.gameScreen.width * 0.999;
    gameAssets.PageMask.height = gameAssets.gameScreen.height * 0.52;
  };


  containers.bgContainer.addChild(gameAssets.PageMask)

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const minWidth = settings.originalWidth;
  const minHeight = settings.originalHeight;

  const scaleX = windowWidth < minWidth ? minWidth / windowWidth : 1;
  const scaleY = windowHeight < minHeight ? minHeight / windowHeight : 1;
  const scale = scaleX > scaleY ? scaleX : scaleY;
  const width = windowWidth * scale;
  const height = windowHeight * scale;

  gameAssets.PageMask.resize(width, height)
}

function setupBackdrop() {
  if (!gameAssets.backdrop) gameAssets.backdrop = new PIXI.Sprite(PIXI.Assets.get('backdrop'))

  gameAssets.backdrop.anchor.set(0.5)
  const width = gameAssets.backdrop.width
  const height = gameAssets.backdrop.height

  gameAssets.backdrop.resize = (w, h) => {
    const scale = scaleFactorScaleToFit(width, height)
    gameAssets.backdrop.x = w * 0.5
    gameAssets.backdrop.y = h * 0.5
    gameAssets.backdrop.width = width * scale
    gameAssets.backdrop.height = height * scale
  }
  containers.backdropContainer.addChild(gameAssets.backdrop)
}

function setupGameScreen() {
  if (!gameAssets.gameScreen) {
    gameAssets.gameScreen = new PIXI.Sprite(PIXI.Assets.get('gameScreen'))
    gameAssets.gameScreen.anchor.set(0.5)
    containers.rootContainer.addChild(gameAssets.gameScreen)
  }
  const width = gameAssets.gameScreen.width
  const height = gameAssets.gameScreen.height
  gameAssets.gameScreen.resize = (w, h) => {
    const expandFactor = 0.97
    const scale = scaleFactor(h, height)
    gameAssets.gameScreen.x = w * 0.5
    gameAssets.gameScreen.y = h * 0.5
    // gameAssets.gameScreen.width = gameAssets.background.width * expandFactor
    // gameAssets.gameScreen.height = gameAssets.background.height
    gameAssets.gameScreen.width = width * scale < w ? width * scale : w
    if (/Mobi|Android|iPhone/i.test(navigator?.userAgent)) {
      gameAssets.gameScreen.width = w
    }
    gameAssets.gameScreen.height = height * scale
    gameAssets.gameScreen.currentScale = scale
  }
  containers.bgContainer.mask = gameAssets.gameScreen
}

function setupBackground() {
  // if(!gameAssets.background) gameAssets.background = new Spine(PIXI.Assets.get('background').spineData)
  if (!gameAssets.background) {
    gameAssets.background = Spine.from({
      skeleton: "background", atlas: "backgroundAtlas", scale: 1,
      boundsProvider: new SkinsAndAnimationBoundsProvider("main_bg", undefined, undefined, true),
    });
    gameAssets.background.state.setAnimation(0, 'main_bg', true)
    gameAssets.background.state.timeScale = 1;
    containers.bgContainer.addChild(gameAssets.background)
  }

  const width = gameAssets.background.getBounds().width
  const height = gameAssets.background.getBounds().height
  let stretch = 0.6;
  gameAssets.background.resize = (w, h) => {
    let expandFactor = 1.05
    if (window.innerHeight / window.innerWidth < 1.45 && /Mobi|Android|iPhone/i.test(navigator?.userAgent)) {
      expandFactor = 1.26
    }
    const scale = scaleFactorScaleToFit(width, height)
    // const expandFactor = 1 // 0.97
    // const scale = scaleFactor(h, height)
    // const scale = scaleFactorFitWidth(w, h, width, height)
    gameAssets.background.x = w * 0.5
    gameAssets.background.y = h * stretch
    gameAssets.background.height = height * scale * expandFactor

    gameAssets.background.width = width * scale * expandFactor
    // gameAssets.background.height = height * scale * expandFactor
    gameAssets.background.currentScale = scale
  }

  pigChickenBackground()
}

const pigChickenBackground = () => {
  // if(!gameAssets.bgPig) gameAssets.bgPig = new Spine(PIXI.Assets.get('background').spineData)
  if (!gameAssets.bgPig) gameAssets.bgPig = Spine.from({ skeleton: "background", atlas: "backgroundAtlas" });

  gameAssets.bgPig.state.setAnimation(0, background.pig, false)
  gameAssets.bgPig.state.timeScale = 1;
  gameAssets.bgPig.zIndex = 5001
  gameAssets.background.addChild(gameAssets.bgPig)


  pigChicken()
}

export const pigChicken = () => {
  const values = Object.values(background)
  const randomIndex = Math.floor(Math.random() * values.length)
  const randomTime = Math.floor(Math.random() * (12 - 5 + 1)) + 5
  gameData.pigAndChickenDelay = gsap.delayedCall(randomTime, () => {

    gameAssets.bgPig.state.setAnimation(0, values[randomIndex], false)
    pigChicken()
  })
}

function setupStrings() {
  if (!gameAssets.string_banderitas_top) gameAssets.string_banderitas_top = new PIXI.Sprite(PIXI.Assets.get('string_banderitas_top'))
  gameAssets.string_banderitas_top.anchor.set(0.5)
  containers.flagsContainer.addChild(gameAssets.string_banderitas_top);

  if (!gameAssets.string_banderitas_middle) gameAssets.string_banderitas_middle = new PIXI.Sprite(PIXI.Assets.get('string_banderitas_middle'))
  gameAssets.string_banderitas_middle.anchor.set(0.5)
  containers.flagsContainer.addChild(gameAssets.string_banderitas_middle);

  if (!gameAssets.string_banderitas_bottom) gameAssets.string_banderitas_bottom = new PIXI.Sprite(PIXI.Assets.get('string_banderitas_bottom'))
  gameAssets.string_banderitas_bottom.anchor.set(0.5)
  containers.flagsContainer.addChild(gameAssets.string_banderitas_bottom);

  gameAssets.string_banderitas_top.zIndex = 5002
  gameAssets.string_banderitas_middle.zIndex = 5002
  gameAssets.string_banderitas_bottom.zIndex = 5001

}

function resetFlagAndPumpPosition() {

  if (pixiApp.app.screen.height / pixiApp.app.screen.width < 1.8 && /Mobi|Android|iPhone/i.test(navigator?.userAgent)) {
    setTimeout(() => {
      containers.flagsContainer.y = containers.flagsContainer.y + 100

      const width = gameAssets.logo.width
      const height = gameAssets.logo.height
      const scale = scaleFactor(gameAssets.gameScreen.width, width)

      gameAssets.logo.width = width * scale * 0.44
      gameAssets.logo.height = height * scale * 0.44
      gameAssets.logo.y = gameAssets.logo.y + 55

      gameAssets.pump.y = 300
      gameAssets.pump.x = 110
      gameAssets.pump.scale.set(0.85)


      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const minWidth = settings.originalWidth;
      const minHeight = settings.originalHeight;

      const scaleX = windowWidth < minWidth ? minWidth / windowWidth : 1;
      const scaleY = windowHeight < minHeight ? minHeight / windowHeight : 1;
      const Scale = scaleX > scaleY ? scaleX : scaleY;
      const h = windowHeight * Scale;

      const normalHeight = h
      const topThreshold = (h / 2 + gameAssets.gameScreen.height / 2)
      gameAssets.footer.y = Math.min(normalHeight, topThreshold) + 30;


    }, 1000)

  }
}

function setupBanderitas() {
  // 1443 3217
  if (gameAssets.banderitasOneBG) banderitasCollection = []

  gameAssets.banderitasOneBG = createSpineBGObject(gameAssets.banderitasOneBG, 'gold_idle', 5)
  gameAssets.banderitasOne = createSpineObject(1, gameAssets.banderitasOne, 'banderitas_blue', 5)
  gameAssets.banderitasOne.under = gameAssets.banderitasOneBG
  banderitasCollection.push(gameAssets.banderitasOne)

  gameAssets.banderitasTwoBG = createSpineBGObject(gameAssets.banderitasTwoBG, 'gold_idle', 4)
  gameAssets.banderitasTwo = createSpineObject(2, gameAssets.banderitasTwo, 'banderitas_violet', 4)
  gameAssets.banderitasTwo.under = gameAssets.banderitasTwoBG
  gameAssets.banderitasTwo.under.interactive = true
  banderitasCollection.push(gameAssets.banderitasTwo)

  gameAssets.banderitasThreeBG = createSpineBGObject(gameAssets.banderitasThreeBG, 'gold_idle')
  gameAssets.banderitasThree = createSpineObject(3, gameAssets.banderitasThree, 'banderitas_red')
  gameAssets.banderitasThree.under = gameAssets.banderitasThreeBG
  banderitasCollection.push(gameAssets.banderitasThree)

  gameAssets.banderitasFourBG = createSpineBGObject(gameAssets.banderitasFourBG, 'gold_idle')
  gameAssets.banderitasFour = createSpineObject(4, gameAssets.banderitasFour, 'banderitas_blue')
  gameAssets.banderitasFour.under = gameAssets.banderitasFourBG
  banderitasCollection.push(gameAssets.banderitasFour)

  gameAssets.banderitasFiveBG = createSpineBGObject(gameAssets.banderitasFiveBG, 'gold_idle', -4)
  gameAssets.banderitasFive = createSpineObject(5, gameAssets.banderitasFive, 'banderitas_blue_green', -4)
  gameAssets.banderitasFive.under = gameAssets.banderitasFiveBG
  banderitasCollection.push(gameAssets.banderitasFive)

  gameAssets.banderitasSixBG = createSpineBGObject(gameAssets.banderitasSixBG, 'gold_idle', -7)
  gameAssets.banderitasSix = createSpineObject(6, gameAssets.banderitasSix, 'banderitas_pink', -7)
  gameAssets.banderitasSix.under = gameAssets.banderitasSixBG
  banderitasCollection.push(gameAssets.banderitasSix)

  gameAssets.banderitasSevenBG = createSpineBGObject(gameAssets.banderitasSevenBG, 'gold_idle', 12)
  gameAssets.banderitasSeven = createSpineObject(7, gameAssets.banderitasSeven, 'banderitas_violet', 12)
  gameAssets.banderitasSeven.under = gameAssets.banderitasSevenBG
  banderitasCollection.push(gameAssets.banderitasSeven)

  gameAssets.banderitasEightBG = createSpineBGObject(gameAssets.banderitasEightBG, 'gold_idle', 7)
  gameAssets.banderitasEight = createSpineObject(8, gameAssets.banderitasEight, 'banderitas_red', 7)
  gameAssets.banderitasEight.under = gameAssets.banderitasEightBG
  banderitasCollection.push(gameAssets.banderitasEight)

  gameAssets.banderitasNineBG = createSpineBGObject(gameAssets.banderitasNineBG, 'gold_idle', 2)
  gameAssets.banderitasNine = createSpineObject(9, gameAssets.banderitasNine, 'banderitas_green', 2)
  gameAssets.banderitasNine.under = gameAssets.banderitasNineBG
  banderitasCollection.push(gameAssets.banderitasNine)

  gameAssets.banderitasOneBG.zIndex = 501
  gameAssets.banderitasOne.zIndex = 502
  gameAssets.banderitasTwoBG.zIndex = 501
  gameAssets.banderitasTwo.zIndex = 502
  gameAssets.banderitasThreeBG.zIndex = 501
  gameAssets.banderitasThree.zIndex = 502
  gameAssets.banderitasFourBG.zIndex = 501
  gameAssets.banderitasFour.zIndex = 502
  gameAssets.banderitasFiveBG.zIndex = 501
  gameAssets.banderitasFive.zIndex = 502
  gameAssets.banderitasSixBG.zIndex = 501
  gameAssets.banderitasSix.zIndex = 502
  gameAssets.banderitasSevenBG.zIndex = 501
  gameAssets.banderitasSeven.zIndex = 502
  gameAssets.banderitasEightBG.zIndex = 501
  gameAssets.banderitasEight.zIndex = 502
  gameAssets.banderitasNineBG.zIndex = 501
  gameAssets.banderitasNine.zIndex = 502
}

function setSessionExpired() {
  if (!gameData.pixiStates) return;
  gameData.pixiStates.setSessionExpired(true)
}

function setupPump() {
  // if(!gameAssets.pump) gameAssets.pump = new Spine(PIXI.Assets.get('ballon_pump').spineData)
  if (!gameAssets.pump) {
    gameAssets.pump = Spine.from({
      skeleton: "ballon_pump", atlas: "ballon_pump_atlas", scale: 1,
      boundsProvider: new SkinsAndAnimationBoundsProvider("ballon_pump_state_01_idle", undefined, undefined, false)
    });
    gameAssets.pump.state.setAnimation(0, pumpIdleAnimation[0], true)
    gameAssets.pump.state.timeScale = 1;
    containers.bgContainer.addChild(gameAssets.pump)
  }

  let yOffset = networkData.isJackpot ? 0.575 : 0.56
  let width = gameAssets.pump.getBounds().width


  gameAssets.pump.resize = (w, h) => {
    let expandFactor = 0.38

    const scale = scaleFactor(gameAssets.gameScreen.width, width)
    const normalHeight = h * yOffset
    const topThreshold = (h / 2 - gameAssets.gameScreen.height / 2)

    gameAssets.pump.x = (w / 2) + (45 * scale)
    gameAssets.pump.y = Math.max(normalHeight, topThreshold)
    gameAssets.pump.scale.set(scale * expandFactor)
  }
}

function setupLogo() {
  if (!gameAssets.logo) gameAssets.logo = new PIXI.Sprite(PIXI.Assets.get('logo'))
  gameAssets.logo.anchor.set(0.5)
  containers.bgContainer.addChild(gameAssets.logo);
  const width = gameAssets.logo.width
  const height = gameAssets.logo.height
  let stretch = 0.43;
  let up = 0;
  if (!networkData.isJackpot && /iPhone/i.test(navigator?.userAgent)) {
    stretch = 0.47;
    up = 80
  } else if (!networkData.isJackpot && /Android/i.test(navigator?.userAgent)) {
    stretch = 0.52;
  }
  gameAssets.logo.resize = (w, h) => {

    if (pixiApp.app.screen.height / pixiApp.app.screen.width < 1.8 && /iPhone/i.test(navigator?.userAgent) && networkData.isJackpot) {
      stretch = 0.38
      up = 45
    } else if (/Android/i.test(navigator?.userAgent) && networkData.isJackpot) {
      stretch = 0.5
      up = 20
    }
    const scale = scaleFactor(gameAssets.gameScreen.width, width)

    gameAssets.logo.width = width * scale * stretch
    gameAssets.logo.height = height * scale * stretch

    gameAssets.logo.x = w * 0.487 - gameAssets.gameScreen.width * 0.5 + gameAssets.logo.width * 0.6

    const normalHeight = h * 0.19
    const topThreshold = (h / 2 - gameAssets.gameScreen.height / 2) * 4
    gameAssets.logo.y = Math.max(normalHeight, topThreshold) - up
  }
}

function setupFooter() {
  if (!gameAssets.footer) gameAssets.footer = new PIXI.Sprite(PIXI.Assets.get('base_container'))
  gameAssets.footer.anchor.set(0.5)
  gameAssets.footer.y = 1350
  gameAssets.footer.zIndex = 7000
  const width = gameAssets.footer.width
  const height = gameAssets.footer.height
  gameAssets.footer.resize = (w, h) => {
    const scale = scaleFactor(gameAssets.gameScreen.width, width)
    const normalHeight = h
    const topThreshold = (h / 2 + gameAssets.gameScreen.height / 2)
    gameAssets.footer.x = w * 0.5
    gameAssets.footer.y = Math.min(normalHeight, topThreshold) + 10
    gameAssets.footer.width = width * scale
    gameAssets.footer.height = height * scale
  }
  containers.bgContainer.addChild(gameAssets.footer)

  if (!gameAssets.char_portrait) gameAssets.char_portrait = new PIXI.Sprite(PIXI.Assets.get('char_portrait'))
  gameAssets.char_portrait.anchor.set(0.5, 0.48)
  gameAssets.char_portrait.x = -450
  gameAssets.char_portrait.y = -450
  // gameAssets.footer.addChild(gameAssets.char_portrait)

  if (!gameAssets.char) gameAssets.char = new PIXI.Sprite(PIXI.Assets.get('male'))
  gameAssets.char.anchor.set(0.5)
  gameAssets.char_portrait.addChild(gameAssets.char)


  if (!gameAssets.nameContainer) gameAssets.nameContainer = new PIXI.Sprite(PIXI.Assets.get('name_container'))
  gameAssets.nameContainer.anchor.set(0.5)
  gameAssets.nameContainer.y = 150
  gameAssets.char_portrait.addChild(gameAssets.nameContainer)

  if (!gameAssets.nameText) gameAssets.nameText = new PIXI.BitmapText('', {
    fontName: 'font-export',
    fontSize: 15,
    letterSpacing: -10
  });
  gameAssets.nameText.y = -15
  gameAssets.nameText.anchor.set(0.5)
  gameAssets.nameContainer.addChild(gameAssets.nameText)


  if (!gameAssets.tickets_container) gameAssets.tickets_container = new PIXI.Sprite(PIXI.Assets.get('container'))
  gameAssets.tickets_container.anchor.set(0.5)
  gameAssets.tickets_container.x = -20
  gameAssets.tickets_container.y = -300
  // gameAssets.footer.addChild(gameAssets.tickets_container)

  if (!gameAssets.tickets) gameAssets.tickets = new PIXI.Sprite(PIXI.Assets.get('tickets'))
  gameAssets.tickets.anchor.set(0.5)
  gameAssets.tickets.x = -20
  gameAssets.tickets.y = -180
  // gameAssets.footer.addChild(gameAssets.tickets)
  viewAppear.view()

  if (!gameAssets.ticketsNumber) gameAssets.ticketsNumber = new PIXI.BitmapText('0', {
    fontName: 'font-export',
    fontSize: 15,
  });
  gameAssets.ticketsNumber.y = -30
  gameAssets.ticketsNumber.anchor.set(0.5)
  gameAssets.tickets_container.addChild(gameAssets.ticketsNumber)

  if (!gameAssets.winnings_container) gameAssets.winnings_container = new PIXI.Sprite(PIXI.Assets.get('container'))
  gameAssets.winnings_container.anchor.set(0.5)
  gameAssets.winnings_container.x = 430
  gameAssets.winnings_container.y = -300
  // gameAssets.footer.addChild(gameAssets.winnings_container)

  if (!gameAssets.winnings) gameAssets.winnings = new PIXI.Sprite(PIXI.Assets.get('winnings'))
  gameAssets.winnings.anchor.set(0.5)
  gameAssets.winnings.x = 430
  gameAssets.winnings.y = -180
  // gameAssets.footer.addChild(gameAssets.winnings)

  if (!gameAssets.winningsNumber) gameAssets.winningsNumber = new PIXI.BitmapText('0', {
    fontName: 'font-export',
    fontSize: 15,
  });
  gameAssets.winningsNumber.y = -30
  gameAssets.winningsNumber.anchor.set(0.5)
  gameAssets.winnings_container.addChild(gameAssets.winningsNumber)


  if (!gameAssets.coin_container) gameAssets.coin_container = new PIXI.Sprite(PIXI.Assets.get('coin_container'))
  gameAssets.coin_container.anchor.set(0.5)
  gameAssets.coin_container.x = -450
  gameAssets.coin_container.y = -160
  // gameAssets.footer.addChild(gameAssets.coin_container)




  //NEW UI FROM HERE
  gameAssets.balanceText = new PIXI.Text('', {
    fontFamily: 'LuckyGuy',
    fontSize: 148,
    align: 'center',
    fill: '#C36D31',
    fontWeight: 500,
  });

  gameAssets.balanceText.y = -10
  gameAssets.balanceText.anchor.set(0.5)

  gameAssets.balance = new PIXI.Text('BALANCE', {
    fontFamily: 'luckyGuy',
    fontSize: 98,
    align: 'center',
    fill: '#C36D31',
    fontWeight: 300,
    letterSpacing: 5
  });

  gameAssets.balance.x = -325
  gameAssets.balance.y = -150
  gameAssets.balance.anchor.set(0.5)
  gameAssets.balance.scale.set(0.5)

  gameAssets.balanceAmount = new PIXI.Text('', {
    fontFamily: 'luckyGuy',
    fontSize: 56,
    align: 'center',
    fill: '#FDD692',
    fontWeight: 400,
    letterSpacing: 3
  });

  gameAssets.balanceAmount.y = -90
  gameAssets.balanceAmount.x = -424
  gameAssets.balanceAmount.anchor.set(0, 0.5)
  gameAssets.balanceAmount.scale.set(1)

  gameAssets.giocoCoin = new PIXI.Sprite(PIXI.Assets.get('giocoCoin'));
  gameAssets.giocoCoin.scale.set(0.7);

  gameAssets.giocoCoin.y = -120
  gameAssets.giocoCoin.x = -500
  gameAssets.giocoCoin.visible = true;

  setupTotalBet()

  if (!gameAssets.betPanel) gameAssets.betPanel = new PIXI.Sprite(PIXI.Assets.get('bet_panel'));
  gameAssets.betPanel.anchor.set(0.5);
  gameAssets.betPanel.x = -358;
  gameAssets.betPanel.y = -268;
  gameAssets.betPanel.sortableChildren = true;
  gameAssets.betPanel.interactive = false;
  gameAssets.betPanel.zIndex = 2;
  gameAssets.betPanel.eventMode = "passive";
  gameAssets.betPanel.scale.set(1.15)

  gameAssets.betHitGraphic = new PIXI.Graphics();

  gameAssets.betHitGraphic.beginFill(0x000000, 1);
  gameAssets.betHitGraphic.drawRect(-70, -18, 140, 65);
  gameAssets.betHitGraphic.endFill();
  gameAssets.betHitGraphic.alpha = 0;
  gameAssets.betHitGraphic.interactive = true;
  gameAssets.betHitGraphic.zIndex = 500
  gameAssets.betHitGraphic.cursor = 'pointer'

  gameAssets.betHitGraphic.on("pointerdown", (event) => {
    event.stopPropagation();
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      toggleBetPanel();
    }
  })

  gameAssets.betPanel.addChild(gameAssets.betHitGraphic)

  if (!gameAssets.gamePanel) gameAssets.gamePanel = new PIXI.Sprite(PIXI.Assets.get('games_panel'));
  gameAssets.gamePanel.anchor.set(0.5);
  gameAssets.gamePanel.x = 358;
  gameAssets.gamePanel.y = -270;
  gameAssets.gamePanel.zIndex = 2;
  gameAssets.gamePanel.scale.set(1.15)
  gameAssets.gamePanel.sortableChildren = true
  gameAssets.gameHitGraphic = new PIXI.Graphics();

  gameAssets.gameHitGraphic.beginFill(0x000000, 1);
  gameAssets.gameHitGraphic.drawRect(-70, -18, 140, 65);
  gameAssets.gameHitGraphic.endFill();
  gameAssets.gameHitGraphic.alpha = 0;
  gameAssets.gameHitGraphic.interactive = true;
  gameAssets.gameHitGraphic.zIndex = 500
  gameAssets.gameHitGraphic.cursor = 'pointer'

  gameAssets.gamePanel.addChild(gameAssets.gameHitGraphic)

  gameAssets.gameHitGraphic.on("pointerdown", (event) => {
    event.stopPropagation()
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      toggleGamePanel();
    }
  })


  setupBetPlusAndMinusBtn()

  gameAssets.betPanel.addChild(gameAssets.plusBtnBetNormal,
    gameAssets.minusBtnBetNormal)

  setupGamesPlusAndMinusBtn()


  gameAssets.gamePanel.addChild(
    gameAssets.minusBtnGameNormal,
    gameAssets.plusBtnGameNormal)

  setupPlayButton()

  setupBetAndGamePopup()

  setupBetAndGameText()

  // setupNumOfGames()

  // setupNumOfBet()

  setupAutoAndTurboPlay();

  setupRemainingTicketsText();
  gameAssets.footer.sortableChildren = true;

  gameAssets.footer.addChild(
    gameAssets.balance,
    gameAssets.balanceAmount,
    gameAssets.giocoCoin,
    gameAssets.totalBet,
    gameAssets.totalBetAmount,
    gameAssets.betSelectContainer,
    gameAssets.gameSelectContainer,
    gameAssets.betPanel,
    gameAssets.gamePanel,
    gameAssets.playButtonNormal,
    ...(networkData.showAutoTurbo
      ? [gameAssets.autoPlayNormalButton, gameAssets.turboPlayNormalButton]
      : [])
  );
  // gameAssets.balanceText.x = 45

  // gameAssets.coin_container.addChild(gameAssets.balanceText)
}

function toggleGamePanel() {
  if (gameAssets.gameSelectContainer.visible) {
    playOff(true)
    gsap.to(gameAssets.gameSelectContainer, {
      duration: 0.4,
      alpha: 0,
      ease: "sine.out",
      onComplete: () => {
        gameAssets.gameSelectContainer.visible = false;
      }
    });
  } else {
    playOn(true)
    gameAssets.gameSelectContainer.alpha = 0;
    gameAssets.gameSelectContainer.visible = true;
    gameAssets.gameNumberContainer.visible = true
    gsap.to(gameAssets.gameSelectContainer, {
      duration: 0.4,
      alpha: 1,
      ease: "sine.in"
    });
  }
}

function toggleBetPanel() {
  if (gameAssets.betSelectContainer.visible) {
    playOff(true)
    gsap.to(gameAssets.betSelectContainer, {
      duration: 0.4,
      alpha: 0,
      ease: "sine.out",
      onComplete: () => {
        gameAssets.betSelectContainer.visible = false;
      }
    });
  } else {
    playOn(true)
    gameAssets.betSelectContainer.alpha = 0;
    gameAssets.betSelectContainer.visible = true;
    gsap.to(gameAssets.betSelectContainer, {
      duration: 0.4,
      alpha: 1,
      ease: "sine.in"
    });
  }
}


function setupRemainingTicketsText() {
  gameAssets.num1 = new PIXI.BitmapText("50", {
    fontName: "font-export",
    fontSize: 21,
    align: "center",
    letterSpacing: -7
  })
  gameAssets.num1.anchor.set(0.5);
  gameAssets.num1.y = -27;
  gameAssets.num1.x = -92;
  gameAssets.num1.visible = false;

  gameAssets.text1 = new PIXI.BitmapText("OF", {
    fontName: "font-export",
    fontSize: 14,
    align: "center",
  })
  gameAssets.text1.anchor.set(0.5)
  gameAssets.text1.y = -17;
  gameAssets.text1.x = 0;
  gameAssets.text1.visible = false;

  gameAssets.num2 = new PIXI.BitmapText("50", {
    fontName: "font-export",
    fontSize: 21,
    align: "center",
    letterSpacing: -7
  })
  gameAssets.num2.anchor.y = 0.5;
  gameAssets.num2.y = -27;
  gameAssets.num2.x = 76;
  gameAssets.num2.visible = false;

  gameAssets.playButtonNormal.addChild(gameAssets.num1, gameAssets.text1, gameAssets.num2)
}

function setupTotalBet() {
  gameAssets.totalBet = new PIXI.Text('TOTAL BeT', {
    fontFamily: 'luckyGuy',
    fontSize: 88,
    align: 'center',
    fill: '#C36D31',
    fontWeight: 300,
    letterSpacing: 4
  });

  gameAssets.totalBet.anchor.set(0.5)
  gameAssets.totalBet.scale.set(0.5)
  gameAssets.totalBet.x = 370
  gameAssets.totalBet.y = -150

  gameAssets.totalBetAmount = new PIXI.Text('', {
    fontFamily: 'luckyGuy',
    fontSize: 70,
    align: 'center',
    fill: '#FDD692',
    fontWeight: 400,
    letterSpacing: 3
  })
  gameAssets.totalBetAmount.anchor.set(0.5);
  gameAssets.totalBetAmount.y = -100
  gameAssets.totalBetAmount.x = 357
}

function setupAutoAndTurboPlay() {
  if (!gameAssets.autoPlayNormalButton) gameAssets.autoPlayNormalButton = new PIXI.Sprite(PIXI.Assets.get('auto_b_normal'));
  gameAssets.autoPlayNormalButton.anchor.set(0.5);
  gameAssets.autoPlayNormalButton.x = -150;
  gameAssets.autoPlayNormalButton.y = -155;

  gameAssets.autoPlaySelected = new PIXI.Sprite(PIXI.Assets.get('auto_b_selected'));
  gameAssets.autoPlaySelected.visible = false;
  gameAssets.autoPlaySelected.anchor.set(0.5);
  gameAssets.autoPlayNormalButton.addChild(gameAssets.autoPlaySelected);

  gameAssets.autoPlayDown = new PIXI.Sprite(PIXI.Assets.get('auto_b_down'));
  gameAssets.autoPlayDown.visible = false;
  gameAssets.autoPlayDown.anchor.set(0.5);

  gameAssets.autoPlayDisable = new PIXI.Sprite(PIXI.Assets.get('auto_b_disable'));
  gameAssets.autoPlayDisable.visible = false;
  gameAssets.autoPlayDisable.anchor.set(0.5);

  gameAssets.autoPlayNormalButton.addChild(gameAssets.autoPlayDown, gameAssets.autoPlayDisable);

  gameAssets.autoPlayHitGraphic = new PIXI.Graphics();
  gameAssets.autoPlayHitGraphic.beginFill(0x202020, 1);
  gameAssets.autoPlayHitGraphic.drawCircle(0, -5, 50);
  gameAssets.autoPlayHitGraphic.endFill();
  gameAssets.autoPlayHitGraphic.interactive = demoState.isDemo ? true : false;
  gameAssets.autoPlayHitGraphic.cursor = "pointer";
  gameAssets.autoPlayHitGraphic.alpha = false
  gameAssets.autoPlayNormalButton.addChild(gameAssets.autoPlayHitGraphic)

  gameAssets.autoPlayHitGraphic.on("pointerdown", async (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      gameAssets.autoPlayDown.visible = true;
      const online = await isOnline()
      if (online || demoState.isDemo) {
        handleAutoPlay()
      } else {
        if (!networkData.buyTickets) {
          networkData.ticketError = true;
        }
        showManualPopup("Internet\nDisconnected");
      }
    }
  })

  gameAssets.autoPlayHitGraphic.on("pointerupoutside", () => {
    gameAssets.autoPlayDown.visible = false;
  })

  gameAssets.autoPlayHitGraphic.on('pointerup', () => {
    gameAssets.autoPlayDown.visible = false;
  })

  //TURBO MODE
  if (!gameAssets.turboPlayNormalButton) gameAssets.turboPlayNormalButton = new PIXI.Sprite(PIXI.Assets.get('speed_b_normal'));
  gameAssets.turboPlayNormalButton.anchor.set(0.5);
  gameAssets.turboPlayNormalButton.x = 150;
  gameAssets.turboPlayNormalButton.y = -155;

  gameAssets.turboPlaySelected = new PIXI.Sprite(PIXI.Assets.get('turbo_b_selected'));
  gameAssets.turboPlaySelected.visible = false;
  gameAssets.turboPlaySelected.anchor.set(0.5);
  gameAssets.turboPlayNormalButton.addChild(gameAssets.turboPlaySelected);

  gameAssets.turboPlayDown = new PIXI.Sprite(PIXI.Assets.get('turbo_b_down'));
  gameAssets.turboPlayDown.visible = false;
  gameAssets.turboPlayDown.anchor.set(0.5);
  gameAssets.turboPlayNormalButton.addChild(gameAssets.turboPlayDown);

  gameAssets.turboPlayDisable = new PIXI.Sprite(PIXI.Assets.get('turbo_b_disable'));
  gameAssets.turboPlayDisable.visible = false;
  gameAssets.turboPlayDisable.anchor.set(0.5);

  gameAssets.turboPlayHitGraphic = new PIXI.Graphics();
  gameAssets.turboPlayHitGraphic.beginFill(0x202020, 1);
  gameAssets.turboPlayHitGraphic.drawCircle(0, -5, 50);
  gameAssets.turboPlayHitGraphic.endFill();
  gameAssets.turboPlayHitGraphic.interactive = demoState.isDemo ? true : false;
  gameAssets.turboPlayHitGraphic.cursor = "pointer";
  gameAssets.turboPlayHitGraphic.alpha = 0
  gameAssets.turboPlayNormalButton.addChild(gameAssets.turboPlayHitGraphic, gameAssets.turboPlayDisable);


  gameAssets.turboPlayHitGraphic.on("pointerdown", async (event) => {
    gameAssets.turboPlayDown.visible = true;
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      const online = await isOnline()
      if (online || demoState.isDemo) {
        handleTurboPlay();
      } else {
        if (!networkData.buyTickets) {
          networkData.ticketError = true;
        }
        showManualPopup("Internet\nDisconnected");
      }
    }
  })

  gameAssets.turboPlayHitGraphic.on("pointerupoutside", () => {
    gameAssets.turboPlayDown.visible = false;
  })

  // gameAssets.turboPlayHitGraphic.on('pointerout', () => {
  //   gameAssets.turboPlaySelected.visible = false;
  // })

  gameAssets.turboPlayHitGraphic.on('pointerup', () => {
    gameAssets.turboPlayDown.visible = false;
  })

}

function setupNumOfBet() {
  gameAssets.gameBetsContainer = new PIXI.Container();

  const startX = 0;
  let startY = 500;
  let spacing = 43;
  let fSize = 28;
  let parSpace = 22;

  if (networkData?.betArray?.length == 7) {
    gameAssets.betSelectContainer.scale.set(1.3, 2.2)
    gameAssets.betSelectContainer.y = -625
    startY = 500;
    spacing = 41;
    fSize = 27;
    parSpace = 22;
  }
  else if (networkData?.betArray?.length == 5) {
    gameAssets.betSelectContainer.scale.set(1.3, 1.9)
    gameAssets.betSelectContainer.y = -540
    spacing = 50;
    fSize = 30
    startY = 505
  } else if (networkData?.betArray?.length == 4) {
    gameAssets.betSelectContainer.scale.set(1.3, 1.7)
    gameAssets.betSelectContainer.y = -480
    spacing = 56;
    fSize = 32
    startY = 510
    parSpace = 25
  } else if (networkData?.betArray?.length == 3) {
    gameAssets.betSelectContainer.scale.set(1.2, 1.4)
    gameAssets.betSelectContainer.y = -430
    spacing = 70;
    fSize = 39
    startY = 513
    parSpace = 34
  } else if (networkData?.betArray?.length == 2) {
    gameAssets.betSelectContainer.scale.set(1, 1)
    gameAssets.betSelectContainer.y = -365
    spacing = 78;
    fSize = 48
    startY = 520
    parSpace = 42
  } else if (networkData?.betArray?.length == 1) {
    gameAssets.betSelectContainer.scale.set(0.9, 0.85)
    gameAssets.betSelectContainer.y = -340
    spacing = 78;
    fSize = 73
    startY = 550
    parSpace = 42
  }

  for (let i = 0; i < networkData.betArray.length; i++) {
    gameAssets.betItemContainer = new PIXI.Container();

    // Create the bet text
    gameAssets.numberOfBets[i] = new PIXI.Text(networkData.betArray[i], {
      fontFamily: "luckyGuy",
      fontSize: fSize,
      fill: "#983000",
      fontWeight: 100,
      letterSpacing: 1,
    });

    gameAssets.numberOfBets[i].anchor.set(0.5);
    gameAssets.numberOfBets[i].interactive = true;
    gameAssets.numberOfBets[i].cursor = "pointer";
    gameAssets.numberOfBets[i].scale.set(1.15);

    // Click event
    gameAssets.numberOfBets[i].on("pointerdown", (event) => {
      if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === "touch") {
        const temp = networkData.betArray[i];
        gameAssets.textOfBets.text = networkData.betArray[i];
        gameData.betAmount = temp;
        networkData.betPoint = networkData.betArray.indexOf(temp);
        gameAssets.totalBetAmount.text = gameData.numberOfGames * gameData.betAmount;
        toggleBetPanel();
      }
    });

    gameAssets.betItemContainer.addChild(gameAssets.numberOfBets[i]);

    // Position bet item
    gameAssets.betItemContainer.x = startX;
    gameAssets.betItemContainer.y = startY + i * spacing; // Arranging vertically

    // Add partitions between bet items
    if (i < networkData.betArray.length - 1) {
      const partition = new PIXI.Sprite(PIXI.Assets.get("bet_game_partition"));
      partition.anchor.set(0.5);
      partition.x = startX;
      partition.y = gameAssets.numberOfBets[i].y + parSpace;
      partition.scale.set(0.3);

      gameAssets.betItemContainer.addChild(partition);
    }

    gameAssets.gameBetsContainer.addChild(gameAssets.betItemContainer);
  }

  gameAssets.gameBetsContainer.x = 0;
  gameAssets.gameBetsContainer.y = -635;
  gameAssets.gameBetsContainer.visible = true;
  gameAssets.betSelectContainer.addChild(gameAssets.gameBetsContainer);
}



function setupBetAndGameText() {

  gameAssets.textOfGames = new PIXI.Text('', {
    fontFamily: "luckyGuy",
    fontSize: 50,
    fontWeight: 100,
    letterSpacing: 5,
  });
  gameAssets.textOfGames.anchor.set(0.5);


  gameAssets.textOfGames.x = 0;
  gameAssets.textOfGames.y = 15;
  gameAssets.textOfGames.scale.set(1)
  gameAssets.textOfGames.visible = true
  gameAssets.gamePanel.addChild(gameAssets.textOfGames);

  gameAssets.textOfBets = new PIXI.Text('', {
    fontFamily: "luckyGuy",
    fontSize: 50,
    fontWeight: 100,
    letterSpacing: 0,
  });
  gameAssets.textOfBets.anchor.set(0.5);
  gameAssets.textOfBets.x = 0;
  gameAssets.textOfBets.y = 15;
  gameAssets.textOfBets.scale.set(1)

  gameAssets.betPanel.addChild(gameAssets.textOfBets)

}

function setupNumOfGames() {

  if (!gameAssets.gameNumberContainer) {
    gameAssets.gameNumberContainer = new PIXI.Container();
  }

  let startX = gameAssets.gameSelectContainer.width / 2;
  let startY = 505;
  let spacing = 55;
  let fSize = 27;

  if (networkData.roundArray.length == 5) {
    fSize = 27
    spacing = 51
    gameAssets.gameSelectContainer.y = gameAssets.gamePanel.y - 240;
  }
  else if (networkData.roundArray.length == 4) {
    fSize = 29;
    spacing = 65
    startY = 512
  } else if (networkData.roundArray.length == 3) {
    fSize = 33;
    spacing = 70
    startY = 518
    gameAssets.gameSelectContainer.y = gameAssets.betPanel.y - 183
  } else if (networkData.roundArray.length == 2) {
    fSize = 35;
    spacing = 75
    startY = 522
    gameAssets.gameSelectContainer.y = gameAssets.betPanel.y - 120
    gameAssets.gameSelectContainer.scale.set(1.1)
  } else if (networkData.roundArray.length == 1) {
    fSize = 35;
    spacing = 75
    startY = 570
    gameAssets.gameSelectContainer.y = gameAssets.betPanel.y - 110
    gameAssets.gameSelectContainer.scale.set(1.1)
  }

  for (let i = 0; i < networkData.roundArray.length; i++) {

    gameAssets.gameItemContainer = new PIXI.Container();

    gameAssets.numberOfGames[i] = new PIXI.Text(networkData.roundArray[i], {
      fontFamily: "luckyGuy",
      fontSize: fSize,
      fill: "#983000",
      fontWeight: 100,
      letterSpacing: 1,
    });
    gameAssets.numberOfGames[i].anchor.set(0.5);
    gameAssets.numberOfGames[i].interactive = true;
    gameAssets.numberOfGames[i].cursor = "pointer";
    gameAssets.numberOfGames[i].x = 0;
    gameAssets.numberOfGames[i].y = 0;
    gameAssets.numberOfGames[i].scale.set(1.2);

    gameAssets.numberOfGames[i].on("pointerdown", (event) => {
      if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
        const temp = networkData.roundArray[i];
        gameAssets.textOfGames.text = gameData.numberOfGames = temp.split(' ')[0]
        networkData.gamePoint = networkData.roundArray.findIndex(text => text.split(" ")[0] === gameAssets.textOfGames.text.toString());
        gameAssets.totalBetAmount.text = gameData.numberOfGames * gameData.betAmount;
        toggleGamePanel()
      }
    });

    gameAssets.gameItemContainer.addChild(gameAssets.numberOfGames[i]);


    if (i < networkData.roundArray.length - 1) {
      gameAssets.partition = new PIXI.Sprite(PIXI.Assets.get("bet_game_partition"));
      gameAssets.partition.anchor.set(0.5);
      gameAssets.partition.x = 0;
      gameAssets.partition.y = gameAssets.numberOfGames[i].height - 10;
      gameAssets.partition.scale.set(0.4)

      gameAssets.gameItemContainer.addChild(gameAssets.partition);
    }
    gameAssets.gameItemContainer.x = startX;
    gameAssets.gameItemContainer.y = startY + i * spacing;
    gameAssets.gameNumberContainer.addChild(gameAssets.gameItemContainer);
  }

  gameAssets.gameNumberContainer.x = -160;
  gameAssets.gameNumberContainer.y = -635
  gameAssets.gameNumberContainer.visible = false;
  gameAssets.gameSelectContainer.addChild(gameAssets.gameNumberContainer);
}

function setupBetAndGamePopup() {
  if (!gameAssets.betSelectContainer) gameAssets.betSelectContainer = new PIXI.Sprite(PIXI.Assets.get('select_container_blank'));
  gameAssets.betSelectContainer.anchor.set(0.5);
  gameAssets.betSelectContainer.y = gameAssets.betPanel.y - 305
  gameAssets.betSelectContainer.x = gameAssets.betPanel.x
  gameAssets.betSelectContainer.visible = false;
  // gameAssets.betSelectContainer.zIndex = 900
  gameAssets.betSelectContainer.scale.set(1.3, 2.1)

  if (!gameAssets.gameSelectContainer) gameAssets.gameSelectContainer = new PIXI.Sprite(PIXI.Assets.get('select_container_blank'));
  gameAssets.gameSelectContainer.anchor.set(0.5);
  gameAssets.gameSelectContainer.x = gameAssets.gamePanel.x
  gameAssets.gameSelectContainer.y = gameAssets.gamePanel.y - 210;

  gameAssets.gameSelectContainer.visible = false;
  gameAssets.gameSelectContainer.scale.set(1.22, 1.5)

}

function setupPlayButton() {
  gameAssets.playButtonNormal = new PIXI.Sprite(PIXI.Assets.get('play_b_normal'));
  gameAssets.playButtonNormal.anchor.set(0.5);
  gameAssets.playButtonNormal.x = 0;
  gameAssets.playButtonNormal.y = -280


  gameAssets.playButtonHover = new PIXI.Sprite(PIXI.Assets.get('play_b_selected'));
  gameAssets.playButtonHover.anchor.set(0.5);
  gameAssets.playButtonHover.visible = false;

  gameAssets.playButtonDown = new PIXI.Sprite(PIXI.Assets.get('play_b_down'));
  gameAssets.playButtonDown.anchor.set(0.5);
  gameAssets.playButtonDown.visible = false;

  gameAssets.playButtonAtPlay = new PIXI.Sprite(PIXI.Assets.get('play_b_atplay'));
  gameAssets.playButtonAtPlay.anchor.set(0.5);
  gameAssets.playButtonAtPlay.visible = false;

  gameAssets.playButtonDisable = new PIXI.Sprite(PIXI.Assets.get('play_b_disable'));
  gameAssets.playButtonDisable.anchor.set(0.5);
  gameAssets.playButtonDisable.visible = false;

  gameAssets.playButtonNormal.addChild(gameAssets.playButtonHover, gameAssets.playButtonDown, gameAssets.playButtonAtPlay, gameAssets.playButtonDisable)

  gameAssets.playHitGraphic = new PIXI.Graphics();
  gameAssets.playHitGraphic.beginFill(0x202020, 1);
  gameAssets.playHitGraphic.drawCircle(0, -7, 140);
  gameAssets.playHitGraphic.endFill();
  gameAssets.playHitGraphic.interactive = false;
  gameAssets.playHitGraphic.alpha = 0
  gameAssets.playHitGraphic.cursor = "pointer";
  gameAssets.playButtonNormal.addChild(gameAssets.playHitGraphic)

  gameAssets.playHitGraphic.on("pointerover", () => {
    gameAssets.playButtonHover.visible = true;
  })

  gameAssets.playHitGraphic.on('pointerout', () => {
    gameAssets.playButtonHover.visible = false;
  })

  gameAssets.playHitGraphic.on('pointerdown', async (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      const online = await isOnline()
      gameAssets.playButtonDown.visible = true;
      if (online || demoState.isDemo) {
        handleTickets()
      } else {
        networkData.ticketError = true;
        showManualPopup("Internet\nDisconnected");
        gameAssets.playButtonDown.visible = false;
      }
    }
  })

  gameAssets.playHitGraphic.on('pointerup', () => {
    gameAssets.playButtonDown.visible = false;
  })

  gameAssets.playHitGraphic.on('pointerupoutside', () => {
    gameAssets.playButtonDown.visible = false;
  });

  gameAssets.playButtonText = new PIXI.BitmapText('5 of 10', {
    fontName: 'font-export',
    fontSize: 70,
    fontWeight: 700
  })

  gameAssets.playButtonText.scale.set(1.3)

  gameAssets.playButtonText.anchor.set(0.5);
  gameAssets.playButtonText.x = 0;
  gameAssets.playButtonText.y = -90
  gameAssets.playButtonText.visible = false

  gameAssets.playButtonNormal.addChild(gameAssets.playButtonText)

}

function setupGamesPlusAndMinusBtn() {
  gameAssets.plusBtnGameNormal = new PIXI.Sprite(PIXI.Assets.get('plus_b_normal'));
  gameAssets.plusBtnGameNormal.anchor.set(0.5);
  gameAssets.plusBtnGameNormal.x = 111;
  gameAssets.plusBtnGameNormal.y = 23;
  gameAssets.plusBtnGameNormal.sortableChildren = true;
  gameAssets.plusBtnGameNormal.scale.set(0.9)

  gameAssets.plusBtnGameHover = new PIXI.Sprite(PIXI.Assets.get('plus_b_selected'));
  gameAssets.plusBtnGameHover.anchor.set(0.5);
  gameAssets.plusBtnGameHover.visible = false;

  gameAssets.plusBtnGameDown = new PIXI.Sprite(PIXI.Assets.get('plus_b_down'));
  gameAssets.plusBtnGameDown.anchor.set(0.5);
  gameAssets.plusBtnGameDown.visible = false;

  gameAssets.plusBtnGameDisable = new PIXI.Sprite(PIXI.Assets.get('plus_b_disable'));
  gameAssets.plusBtnGameDisable.anchor.set(0.5);
  gameAssets.plusBtnGameDisable.visible = false;

  gameAssets.gamesPlusHitGraphic = new PIXI.Graphics();
  gameAssets.gamesPlusHitGraphic.beginFill(0x202020, 1);
  gameAssets.gamesPlusHitGraphic.drawCircle(0, -8, 47);
  gameAssets.gamesPlusHitGraphic.endFill();
  gameAssets.gamesPlusHitGraphic.interactive = true;
  gameAssets.gamesPlusHitGraphic.alpha = 0
  gameAssets.gamesPlusHitGraphic.zIndex = 500
  gameAssets.gamesPlusHitGraphic.cursor = "pointer";
  gameAssets.plusBtnGameNormal.addChild(gameAssets.gamesPlusHitGraphic)

  gameAssets.plusBtnGameNormal.addChild(gameAssets.plusBtnGameHover, gameAssets.plusBtnGameDown, gameAssets.plusBtnGameDisable)

  gameAssets.gamesPlusHitGraphic.on("pointerover", () => {
    gameAssets.plusBtnGameHover.visible = true;
  })

  gameAssets.gamesPlusHitGraphic.on('pointerout', () => {
    gameAssets.plusBtnGameHover.visible = false;
  })

  gameAssets.gamesPlusHitGraphic.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

      gameAssets.plusBtnGameDown.visible = true
      if (networkData.gamePoint > 0) {
        playPlus(true)
        networkData.gamePoint = networkData.gamePoint - 1;
        const temp = networkData.roundArray[networkData.gamePoint];
        gameAssets.textOfGames.text = gameData.numberOfGames = temp.split(' ')[0]
        gameAssets.totalBetAmount.text = gameData.numberOfGames * gameData.betAmount;
      } else {
        playDisable(true)
      }
    }

  })

  gameAssets.gamesPlusHitGraphic.on('pointerup', () => {
    gameAssets.plusBtnGameDown.visible = false;
  })

  gameAssets.gamesPlusHitGraphic.on('pointerupoutside', () => {
    gameAssets.plusBtnGameDown.visible = false;
  });

  gameAssets.minusBtnGameNormal = new PIXI.Sprite(PIXI.Assets.get('minus_b_normal'));
  gameAssets.minusBtnGameNormal.anchor.set(0.5);
  gameAssets.minusBtnGameNormal.x = -113;
  gameAssets.minusBtnGameNormal.y = 25;
  gameAssets.minusBtnGameNormal.eventMode = 'passive'
  gameAssets.minusBtnGameNormal.sortableChildren = true;
  gameAssets.minusBtnGameNormal.scale.set(0.9)

  gameAssets.minusBtnGameHover = new PIXI.Sprite(PIXI.Assets.get('minus_b_selected'));
  gameAssets.minusBtnGameHover.anchor.set(0.5);
  gameAssets.minusBtnGameHover.visible = false;

  gameAssets.minusBtnGameDown = new PIXI.Sprite(PIXI.Assets.get('minus_b_down'));
  gameAssets.minusBtnGameDown.anchor.set(0.5);
  gameAssets.minusBtnGameDown.visible = false;

  gameAssets.minusBtnGameDiable = new PIXI.Sprite(PIXI.Assets.get('minus_b_disable'));
  gameAssets.minusBtnGameDiable.anchor.set(0.5);
  gameAssets.minusBtnGameDiable.visible = false;
  gameAssets.minusBtnGameDiable.eventMode = 'passive'

  gameAssets.gamesminusHitGraphic = new PIXI.Graphics();
  gameAssets.gamesminusHitGraphic.beginFill(0x202020, 1);
  gameAssets.gamesminusHitGraphic.drawCircle(0, -8, 47);
  gameAssets.gamesminusHitGraphic.endFill();
  gameAssets.gamesminusHitGraphic.interactive = true;
  gameAssets.gamesminusHitGraphic.alpha = 0
  gameAssets.gamesminusHitGraphic.zIndex = 500
  gameAssets.gamesminusHitGraphic.cursor = "pointer";

  gameAssets.minusBtnGameNormal.addChild(gameAssets.minusBtnGameHover, gameAssets.minusBtnGameDown, gameAssets.gamesminusHitGraphic, gameAssets.minusBtnGameDiable)

  gameAssets.gamesminusHitGraphic.on("pointerover", () => {
    gameAssets.minusBtnGameHover.visible = true;
  })

  gameAssets.gamesminusHitGraphic.on('pointerout', () => {
    gameAssets.minusBtnGameHover.visible = false;
  })

  gameAssets.gamesminusHitGraphic.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

      gameAssets.minusBtnGameDown.visible = true

      if (networkData.gamePoint < networkData.roundArray.length - 1) {
        playMinus(true)
        networkData.gamePoint = networkData.gamePoint + 1;
        const temp = networkData.roundArray[networkData.gamePoint];
        gameAssets.textOfGames.text = gameData.numberOfGames = temp.split(' ')[0]
        gameAssets.totalBetAmount.text = gameData.numberOfGames * gameData.betAmount;
      } else {
        playDisable(true)
      }
    }
  })

  gameAssets.gamesminusHitGraphic.on('pointerup', () => {
    gameAssets.minusBtnGameDown.visible = false;
  })

  gameAssets.gamesminusHitGraphic.on('pointerupoutside', () => {
    gameAssets.minusBtnGameDown.visible = false;
  });
}

function setupBetPlusAndMinusBtn() {
  gameAssets.plusBtnBetNormal = new PIXI.Sprite(PIXI.Assets.get('plus_b_normal'));
  gameAssets.plusBtnBetNormal.anchor.set(0.5);
  gameAssets.plusBtnBetNormal.x = 111;
  gameAssets.plusBtnBetNormal.y = 25
  gameAssets.plusBtnBetNormal.eventMode = 'passive'
  gameAssets.plusBtnBetNormal.scale.set(0.9)

  gameAssets.plusBtnBetHover = new PIXI.Sprite(PIXI.Assets.get('plus_b_selected'));
  gameAssets.plusBtnBetHover.anchor.set(0.5);
  gameAssets.plusBtnBetHover.visible = false;

  gameAssets.plusBtnBetDown = new PIXI.Sprite(PIXI.Assets.get('plus_b_down'));
  gameAssets.plusBtnBetDown.anchor.set(0.5);
  gameAssets.plusBtnBetDown.visible = false;

  gameAssets.plusBtnBetDisable = new PIXI.Sprite(PIXI.Assets.get('plus_b_disable'));
  gameAssets.plusBtnBetDisable.anchor.set(0.5);
  gameAssets.plusBtnBetDisable.visible = false;
  gameAssets.plusBtnBetDisable.eventMode = 'passive'

  gameAssets.betPlusHitGraphic = new PIXI.Graphics();
  gameAssets.betPlusHitGraphic.beginFill(0x202020, 1);
  gameAssets.betPlusHitGraphic.drawCircle(0, -8, 47);
  gameAssets.betPlusHitGraphic.endFill();
  gameAssets.betPlusHitGraphic.interactive = true;
  gameAssets.betPlusHitGraphic.alpha = 0
  gameAssets.betPlusHitGraphic.cursor = "pointer";

  gameAssets.plusBtnBetNormal.addChild(gameAssets.plusBtnBetHover, gameAssets.plusBtnBetDown, gameAssets.betPlusHitGraphic, gameAssets.plusBtnBetDisable)

  gameAssets.betPlusHitGraphic.on("pointerover", () => {
    gameAssets.plusBtnBetHover.visible = true;
  })

  gameAssets.betPlusHitGraphic.on('pointerout', () => {
    gameAssets.plusBtnBetHover.visible = false;
  })

  gameAssets.betPlusHitGraphic.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

      gameAssets.plusBtnBetDown.visible = true
      if (networkData.betPoint > 0) {
        playPlus(true)
        networkData.betPoint = networkData.betPoint - 1;
        const temp = networkData.betArray[networkData.betPoint];
        gameAssets.textOfBets.text = gameData.betAmount = temp
        gameAssets.totalBetAmount.text = gameData.numberOfGames * gameData.betAmount;
      } else {
        playDisable(true)
      }
    }
  })

  gameAssets.betPlusHitGraphic.on('pointerup', () => {
    gameAssets.plusBtnBetDown.visible = false;
  })

  gameAssets.betPlusHitGraphic.on('pointerupoutside', () => {
    gameAssets.plusBtnBetDown.visible = false;
  });


  gameAssets.minusBtnBetNormal = new PIXI.Sprite(PIXI.Assets.get('minus_b_normal'));
  gameAssets.minusBtnBetNormal.anchor.set(0.5);
  gameAssets.minusBtnBetNormal.x = -108
  gameAssets.minusBtnBetNormal.y = 26
  gameAssets.minusBtnBetNormal.scale.set(0.9)

  gameAssets.minusBtnBetHover = new PIXI.Sprite(PIXI.Assets.get('minus_b_selected'));
  gameAssets.minusBtnBetHover.anchor.set(0.5);
  gameAssets.minusBtnBetHover.visible = false;

  gameAssets.minusBtnBetDown = new PIXI.Sprite(PIXI.Assets.get('minus_b_down'));
  gameAssets.minusBtnBetDown.anchor.set(0.5);
  gameAssets.minusBtnBetDown.visible = false;

  gameAssets.minusBtnBetDisable = new PIXI.Sprite(PIXI.Assets.get('minus_b_disable'));
  gameAssets.minusBtnBetDisable.anchor.set(0.5);
  gameAssets.minusBtnBetDisable.visible = false;

  gameAssets.betMinusHitGraphic = new PIXI.Graphics();
  gameAssets.betMinusHitGraphic.beginFill(0x202020, 1);
  gameAssets.betMinusHitGraphic.drawCircle(0, -8, 47);
  gameAssets.betMinusHitGraphic.endFill();
  gameAssets.betMinusHitGraphic.interactive = true;
  gameAssets.betMinusHitGraphic.alpha = 0
  gameAssets.betMinusHitGraphic.cursor = "pointer";

  gameAssets.minusBtnBetNormal.addChild(gameAssets.minusBtnBetHover, gameAssets.minusBtnBetDown, gameAssets.betMinusHitGraphic, gameAssets.minusBtnBetDisable)

  gameAssets.betMinusHitGraphic.on("pointerover", () => {
    gameAssets.minusBtnBetHover.visible = true;
  })

  gameAssets.betMinusHitGraphic.on('pointerout', () => {
    gameAssets.minusBtnBetHover.visible = false;
  })

  gameAssets.betMinusHitGraphic.on('pointerdown', (event) => {

    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

      gameAssets.minusBtnBetDown.visible = true
      if (networkData.betPoint < networkData.betArray.length - 1) {
        playMinus(true)
        networkData.betPoint = networkData.betPoint + 1;
        const temp = networkData.betArray[networkData.betPoint];
        gameAssets.textOfBets.text = gameData.betAmount = temp
        gameAssets.totalBetAmount.text = gameData.numberOfGames * gameData.betAmount;
      } else {
        playDisable(true)
      }
    }
  })

  gameAssets.betMinusHitGraphic.on('pointerup', () => {
    gameAssets.minusBtnBetDown.visible = false;
  })

  gameAssets.betMinusHitGraphic.on('pointerupoutside', () => {
    gameAssets.minusBtnBetDown.visible = false;
  });
}

function updateBalanceText() {
  const maxWidth = gameAssets.coin_container.width - 120;

  if (gameAssets.balanceText.textWidth > maxWidth) {
    const scale = maxWidth / gameAssets.balanceText.textWidth;
    gameAssets.balanceText.scale.set(scale);
  } else {
    gameAssets.balanceText.scale.set(1);
  }

  gameAssets.balanceText.x = 50;
}

function setupMenuButton() {
  if (!gameAssets.menu) gameAssets.menu = new PIXI.Sprite(PIXI.Assets.get('menu_b_normal'))
  gameAssets.menu.anchor.set(0.5)
  gameAssets.menu.zIndex = 5003
  containers.bgContainer.addChild(gameAssets.menu)
  const width = gameAssets.menu.width
  const height = gameAssets.menu.height

  gameAssets.menuGraphic = new PIXI.Graphics();
  gameAssets.menuGraphic.beginFill(0x000000, 0.5);
  gameAssets.menuGraphic.pivot.set(0.5)
  gameAssets.menuGraphic.drawRoundedRect(-73, -75, 152, 152, 20);

  gameAssets.menuDisable = new PIXI.Sprite(PIXI.Assets.get('menu_b_disabled'));
  gameAssets.menuDisable.anchor.set(0.5)
  gameAssets.menuDisable.visible = false;

  gameAssets.menuGraphic.endFill();

  gameAssets.menuGraphic.visible = false;

  gameAssets.menu.addChild(gameAssets.menuGraphic, gameAssets.menuDisable)

  gameAssets.menu.resize = (w, h) => {
    const scale = scaleFactor(gameAssets.gameScreen.width, width)

    const normalHeight = h * 0.04
    const topThreshold = (h / 2 - gameAssets.gameScreen.height / 2) * 1.8

    gameAssets.menu.x = w * 0.5 - gameAssets.gameScreen.width * 0.4
    gameAssets.menu.y = Math.max(normalHeight, topThreshold)

    gameAssets.menu.width = width * scale * 0.1
    gameAssets.menu.height = height * scale * 0.1
  }
  gameAssets.menu.interactive = true
  gameAssets.menu.buttonMode = true
  gameAssets.menu.on('pointerover', () => { gameAssets.menu.cursor = 'pointer'; gameAssets.menu.texture = PIXI.Assets.get('menu_b_selected') })
  gameAssets.menu.on('pointerout', () => { gameAssets.menu.texture = PIXI.Assets.get('menu_b_normal') })
  gameAssets.menu.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      setIsPopupOpen(true)
      gameData.isPopupOpen = true
      playPopUpOpen(true)
      tweenFade(containers.popupContainer, true, 0.2)
      tweenFade(gameAssets.dimmer, true, 0.2)
      containers.popupContainer.interactiveChildren = true
      gameAssets.footer.visible = false;
    }
  })
}


function setupCommendation() {
  containers.bgContainer.addChild(containers.coinsContainer)
  // if(!gameAssets.commendation) gameAssets.commendation = new Spine(PIXI.Assets.get('commendation').spineData)
  if (!gameAssets.commendation) gameAssets.commendation = Spine.from({
    skeleton: "commendation", atlas: "commendationAtlas", scale: 1,
    boundsProvider: new SkinsAndAnimationBoundsProvider("version 1/bigwin", undefined, undefined, false),
  });
  gameAssets.commendation.zIndex = 7000
  gameAssets.commendation.state.setAnimation(0, 'version 1/bigwin', false)
  gameAssets.commendation.state.timeScale = 1
  gameAssets.commendation.visible = false
  containers.bgContainer.addChild(gameAssets.commendation)
  const width = gameAssets.commendation.getBounds().width
  const height = gameAssets.commendation.getBounds().height
  gameAssets.commendation.resize = (w, h) => {
    const expandFactor = 2.3
    const scale = scaleFactor(gameAssets.gameScreen.width, width)
    gameAssets.commendation.x = w * 0.5
    gameAssets.commendation.y = h * 0.5
    gameAssets.commendation.width = width * scale * expandFactor
    gameAssets.commendation.height = height * scale * expandFactor
  }
  gameAssets.commendation.interactive = false
  gameAssets.commendation.buttonMode = true
  gameAssets.commendation.on('pointerdown', () => {
    controlWinFlow()
  })

  if (!gameAssets.commendationValueBitmap) gameAssets.commendationValueBitmap = new PIXI.BitmapText('55555', {
    fontName: 'font-export',
    fontSize: 30,
  })
  gameAssets.commendationValueBitmap.y = 250
  gameAssets.commendationValueBitmap.zIndex = 501;
  gameAssets.commendationValueBitmap.anchor.set(0.5)
  gameAssets.commendation.addChild(gameAssets.commendationValueBitmap)
  gameAssets.commendationValueBitmap.initialWidth = gameAssets.commendationValueBitmap.width
  gameAssets.commendationValueBitmap.initialHeight = gameAssets.commendationValueBitmap.height
  gameAssets.commendationValueBitmap.scale.set(0)


}

const setCommendationValueBitmap = number => {
  gameAssets.commendationValueBitmap.text = number
}

function setupAmazing() {
  // if(!gameAssets.amazing) gameAssets.amazing = new Spine(PIXI.Assets.get('jackpot').spineData)
  if (!gameAssets.amazing) gameAssets.amazing = Spine.from({
    skeleton: "jackpot", atlas: "jackpotAtlas", scale: 1,
    boundsProvider: new SkinsAndAnimationBoundsProvider('jackpot/fx_loop', undefined, undefined, false),
  });
  gameAssets.amazing.zIndex = 7000

  gameAssets.amazing.state.setAnimation(0, 'jackpot/fx_loop', true)
  gameAssets.amazing.state.timeScale = 1
  gameAssets.amazing.visible = false
  containers.bgContainer.addChild(gameAssets.amazing)
  const width = gameAssets.amazing.getBounds().width
  const height = gameAssets.amazing.getBounds().height
  gameAssets.amazing.resize = (w, h) => {
    const expandFactor = 2.3
    const scale = scaleFactor(gameAssets.gameScreen.width, width)
    gameAssets.amazing.x = w * 0.5
    gameAssets.amazing.y = h * 0.5
    gameAssets.amazing.width = width * scale * expandFactor
    gameAssets.amazing.height = height * scale * expandFactor
  }
  gameAssets.amazing.interactive = false
  gameAssets.amazing.buttonMode = true
  gameAssets.amazing.on('pointerdown', () => {
    clickToStopCommendation()
  })

  if (!gameAssets.amazingBitmap) gameAssets.amazingBitmap = new PIXI.BitmapText('AMAZING', {
    fontName: 'font-export',
    fontSize: 45,
  })
  gameAssets.amazingBitmap.visible = false
  gameAssets.amazingBitmap.y = -200
  gameAssets.amazingBitmap.zIndex = 501;
  gameAssets.amazingBitmap.anchor.set(0.5)
  gameAssets.amazing.addChild(gameAssets.amazingBitmap)
  gameAssets.amazingBitmap.initialWidth = gameAssets.amazingBitmap.width
  gameAssets.amazingBitmap.initialHeight = gameAssets.amazingBitmap.height

  if (!gameAssets.amazingWinValueBitmap) gameAssets.amazingWinValueBitmap = new PIXI.BitmapText('333', {
    fontName: 'font-export',
    fontSize: 30,
  })
  gameAssets.amazingWinValueBitmap.scale.set(0)
  gameAssets.amazingWinValueBitmap.y = 250
  gameAssets.amazingWinValueBitmap.zIndex = 501
  gameAssets.amazingWinValueBitmap.anchor.set(0.5)
  gameAssets.amazing.addChild(gameAssets.amazingWinValueBitmap)
  gameAssets.amazingWinValueBitmap.initialWidth = gameAssets.amazingWinValueBitmap.width
  gameAssets.amazingWinValueBitmap.initialHeight = gameAssets.amazingWinValueBitmap.height
}

const setAmazingWinValueBitmap = number => {
  gameAssets.amazingWinValueBitmap.text = number
}

function setupContainers() {
  pixiApp.app.stage.addChild(containers.backdropContainer, containers.rootContainer, containers.popupContainer)

  containers.rootContainer.name = "RootContainer";
  containers.popupContainer.name = "popupContainer";
  containers.rootContainer.addChild(containers.bgContainer)
  containers.bgContainer.addChild(containers.flagsContainer);
  containers.bgContainer.sortableChildren = true
  containers.flagsContainer.zIndex = 5000
  pixiApp.app.stage.sortableChildren = true
  containers.backdropContainer.zIndex = 1
  containers.rootContainer.zIndex = 2
  containers.popupContainer.zIndex = 3

}

function ShowInsufficientBalancePopup() {
  popUpShow("INSUFFICIENT\nBALANCE")
}

function showErrorPopup() {
  popUpShow("INTERNET\nDISCONNECTED")
}

function shownNetworkErrorPopup() {
  popUpShow("NETWORK\nERROR")
}

function showManualPopup(str) {
  popUpShow(str)
}

const resetPixiGame = (x, y) => {
  // background 3217 / 1443
  if (!uiCreated) return

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const minWidth = settings.originalWidth;
  const minHeight = settings.originalHeight;

  const scaleX = windowWidth < minWidth ? minWidth / windowWidth : 1;
  const scaleY = windowHeight < minHeight ? minHeight / windowHeight : 1;
  const scale = scaleX > scaleY ? scaleX : scaleY;
  const width = windowWidth * scale;
  const height = windowHeight * scale;

  gameAssets.gameScreen.windowWidth = windowWidth
  gameAssets.gameScreen.windowHeight = windowHeight
  settings.currentWidth = width
  settings.currentHeight = height
  gameAssets.gameScreen.viewAppear()

  gameAssets.backdrop.resize(width, height)
  gameAssets.background.resize(width, height)
  gameAssets.gameScreen.resize(width, height)

  gameAssets.banderitasOne.resize(-400, -570, width, height)
  gameAssets.banderitasOneBG.resize(-400, -570, width, height)

  gameAssets.banderitasTwo.resize(5, -550, width, height)
  gameAssets.banderitasTwoBG.resize(5, -550, width, height)

  gameAssets.banderitasThree.resize(440, -540, width, height)
  gameAssets.banderitasThreeBG.resize(440, -540, width, height)

  gameAssets.banderitasFour.resize(-390, -160, width, height)
  gameAssets.banderitasFourBG.resize(-390, -160, width, height)

  gameAssets.banderitasFive.resize(10, -170, width, height)
  gameAssets.banderitasFiveBG.resize(10, -170, width, height)

  gameAssets.banderitasSix.resize(420, -200, width, height)
  gameAssets.banderitasSixBG.resize(420, -200, width, height)

  gameAssets.banderitasSeven.resize(-420, 160, width, height)
  gameAssets.banderitasSevenBG.resize(-420, 160, width, height)

  gameAssets.banderitasEight.resize(-40, 220, width, height)
  gameAssets.banderitasEightBG.resize(-40, 220, width, height)

  gameAssets.banderitasNine.resize(400, 240, width, height)
  gameAssets.banderitasNineBG.resize(400, 240, width, height)
  gameAssets.pump.resize(width, height)
  gameAssets.logo.resize(width, height)
  gameAssets.menu.resize(width, height)
  gameAssets.footer.resize(width, height)
  gameAssets.commendation.resize(width, height)
  gameAssets.amazing.resize(width, height)
  gameAssets.settingsBase.resize(width, height)
  gameAssets.dimmer.resize(width, height)
  gameAssets.coin1.resize(width, height)
  gameAssets?.ftueArrow?.resize(width, height)
  // gameAssets?.FTUEpopUp?.resize(width, height)
  // gameAssets?.skip?.resize(width, height)
  // gameAssets?.tutorialCont?.resize(width, height)
  // gameAssets?.tutorialFootCont?.resize(width,height)
  gameAssets?.jackpotPanelContainer?.resize(width, height)
  gameAssets?.tutorialBase?.resize(width, height)
  gameAssets.betHistoryBase.resize(width, height)
  // gameAssets?.PageMask?.resize(width,height)

  gameAssets.loseMessage.resize(width, height)
  gameAssets.popUpBase.resize(width, height)
}

const resetFtuePanel = () => {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const minWidth = settings.originalWidth;
  const minHeight = settings.originalHeight;

  const scaleX = windowWidth < minWidth ? minWidth / windowWidth : 1;
  const scaleY = windowHeight < minHeight ? minHeight / windowHeight : 1;
  const scale = scaleX > scaleY ? scaleX : scaleY;
  const width = windowWidth * scale;
  const height = windowHeight * scale;

  gameAssets.FTUEpopUp.resize(width, height)
}

const resetTutorial = () => {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const minWidth = settings.originalWidth;
  const minHeight = settings.originalHeight;

  const scaleX = windowWidth < minWidth ? minWidth / windowWidth : 1;
  const scaleY = windowHeight < minHeight ? minHeight / windowHeight : 1;
  const scale = scaleX > scaleY ? scaleX : scaleY;
  const width = windowWidth * scale;
  const height = windowHeight * scale;

  gameAssets?.tutorialBase?.resize(width, height)
}

window.addEventListener('resize', function (event) {
  resetPixiGame(window.innerWidth, window.innerHeight)
}, true);


export {
  containers,
  banderitasCollection,
  gameAssets,
  uiCreated,
  createAppUI,
  showErrorPopup,
  shownNetworkErrorPopup,
  showManualPopup,
  ShowInsufficientBalancePopup,
  resetPixiGame,
  setCommendationValueBitmap,
  setAmazingWinValueBitmap,
  updateBalanceText,
  toggleBetPanel,
  setupNumOfBet,
  toggleGamePanel,
  setupFTUE,
  setupNumOfGames,
  resetFtuePanel,
  resetTutorial,
  setSessionExpired,
  ftueScroll
}
